/**
 * Superficie pública del bounded context Inventory.
 * Re-exporta desde app-api + stock/public-api + UI directa.
 */
// Side-effect import movido a src/init/sessionResetRegistrations.ts (cargado en App.tsx).

export * from './app-api';

// Re-exports from stock module for boundary compliance
export * from './stock/public-api';
